export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'e9bbe40b-4793-419b-ad38-7b7d8e656d18';
export const MODEL_CLOSE_SEC = 2.5;
